import { useState } from 'react';
import styles from './TagsListSkeleton.module.scss';
import classNames from 'classnames';

interface TagsListProps {
  className?: string;
}

export default function TagsListSkeleton({ className }: TagsListProps) {
  const [blocksCount, setBlocksCount] = useState<number>(10);

  return (
    <div className={classNames(styles.root, className && className)}>
      {[...Array(blocksCount)].map((value, index) => (
        <div
          className={styles.block}
          key={index}
        >
          <div className={styles.icon}></div>
          <div className={styles.label}></div>
        </div>
      ))}
    </div>
  );
}
